import { FlexBox } from '@airship-platform/jam-web/components';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { Fragment } from 'react';

const NO_DATA_MESSAGE = 'No data yet';

export interface BreakdownItem {
  label: React.ReactNode;
  metric: React.ReactNode;
}

interface OwnProps {
  isLoading: boolean;
  title: string;
  items: BreakdownItem[];
}

const SKELETON_ROWS = new Array(3).fill(null).map(() => ({
  label: <Skeleton width={140} />,
  metric: <Skeleton width={72} />,
}));

const BreakdownRow: React.FC<{ item: BreakdownItem }> = ({ item }) => (
  <FlexBox
    justifyContent={'space-between'}
    alignItems={'center'}
    gap={2}
    py={1}
  >
    <Typography variant={'body3'}>{item.label}</Typography>
    <Typography variant={'body4'} color={'text.secondary'}>
      {item.metric}
    </Typography>
  </FlexBox>
);

const BreakdownCard: React.FC<OwnProps> = ({ isLoading, title, items }) => {
  const rows = isLoading ? SKELETON_ROWS : items;

  return (
    <Card variant={'bordered'} sx={{ flex: 1 }}>
      <FlexBox flexDirection={'column'} gap={1}>
        <Typography variant={'body3'} color={'text.secondary'}>
          {title}
        </Typography>
        <FlexBox flexDirection={'column'}>
          {rows.length ? (
            rows.map((item, index) => (
              <Fragment key={index}>
                {index > 0 && <Divider />}
                <BreakdownRow item={item} />
              </Fragment>
            ))
          ) : (
            <FlexBox p={1}>
              <Typography variant={'body3'} color={'text.secondary'}>
                {NO_DATA_MESSAGE}
              </Typography>
            </FlexBox>
          )}
        </FlexBox>
      </FlexBox>
    </Card>
  );
};

export default BreakdownCard;
